// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1IL1x","addWidgetButton":"Header_addWidgetButton__32-Kp","dashboardTabs":"Header_dashboardTabs__3m3zO","active":"Header_active__1TB3D"};